(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_best_seller"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector(".new-slide");
    if (slider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(slider).slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 896,
            settings: {
              infinite: true,
              centerMode: true,
              centerPadding: '20%',
              slidesToShow: 1,
              autoplay: false,
              arrows: false,
              dots: false,
            },
          },
        ],
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_side-nav"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var navController = null;
  var toggleController = null;

  function handleNav() {
    if (navController) navController.abort();
    navController = new AbortController();
    var signal = navController.signal;
    // 20260714: CSSのブレークポイント統一(896px)に合わせてJSも768→896に変更
    var isSp = window.matchMedia('(max-width: 896px)').matches;

    if (isSp) {
      // SP: クリックでアコーディオン
      document.querySelectorAll('.side-nav-l1-anchor').forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
          var wrapper = anchor.parentElement.querySelector('.mega-menu-wrapper');
          if (wrapper) {
            e.preventDefault();
            var isOpen = anchor.classList.toggle('is-open');
            wrapper.style.display = isOpen ? 'block' : 'none';
          }
        }, { signal: signal });
      });
    } else {
      // PC: ホバーでメガメニュー
      document.querySelectorAll('.mega-menu-wrapper').forEach(function (w) {
        w.style.display = 'none';
      });
      document.querySelectorAll('.side-nav-l1-anchor').forEach(function (anchor) {
        anchor.classList.remove('is-open');
      });
      document.querySelectorAll('.side-nav-l1-item').forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          var wrapper = item.querySelector('.mega-menu-wrapper');
          if (wrapper) wrapper.style.display = 'block';
        }, { signal: signal });
        item.addEventListener('mouseleave', function () {
          var wrapper = item.querySelector('.mega-menu-wrapper');
          if (wrapper) wrapper.style.display = 'none';
        }, { signal: signal });
      });
    }
  }

  function handleSideNavToggle() {
    if (toggleController) toggleController.abort();
    toggleController = new AbortController();
    var signal = toggleController.signal;
    // 20260714: CSSのブレークポイント統一(896px)に合わせてJSも768→896に変更
    var isSp = window.matchMedia('(max-width: 896px)').matches;
    var trigger = document.querySelector('.side-nav-sp-trigger');
    var content = document.querySelector('.side-nav-sp-content');

    if (!trigger || !content) return;

    if (isSp) {
      // SP: 開閉ロジックをバインド（初期は閉じた状態に統一）
      trigger.classList.remove('is-open');
      content.style.display = 'none';
      trigger.addEventListener('click', function () {
        var isOpen = trigger.classList.toggle('is-open');
        content.style.display = isOpen ? 'block' : 'none';
      }, { signal: signal });
    } else {
      // PC: イベントを解除し、コンテンツを常に表示状態にする
      trigger.classList.remove('is-open');
      content.style.display = 'block';
    }
  }

  // 初期読み込み時に両方の関数を実行
  handleNav();
  handleSideNavToggle();

  // ウィンドウリサイズ時にも実行
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      handleNav();
      handleSideNavToggle();
    }, 250);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  $(".faq-question").each(function() {
    $(this).on("click", function() {
      if ($(this).parent(".faq-item").hasClass("is-open")) {
        $(this).parent(".faq-item").removeClass("is-open");
        $(this).next(".faq-answer").stop().slideUp("fast");
      } else {
        $(this).parent(".faq-item").addClass("is-open");
        $(this).next(".faq-answer").stop().slideDown("fast");
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    if (!window.matchMedia('(max-width: 896px)').matches) return;
    document.querySelectorAll('.footer-main-item-ttl').forEach(function (ttl) {
      var ul = ttl.nextElementSibling;
      if (ul) ul.style.display = 'none';
      ttl.addEventListener('click', function () {
        if (this.classList.contains('is-open')) {
          this.classList.remove('is-open');
          ul.style.display = 'none';
        } else {
          this.classList.add('is-open');
          ul.style.display = 'block';
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  $(function() {
    $('.customer-tab__item').on('click', function() {
      $('.customer-tab__item, .customer-detail-box').removeClass('is-current');
    
      $(this).addClass('is-current');
       
      var index = $('.customer-tab__item').index(this);
      $('.customer-detail-box').eq(index).addClass('is-current');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__bosai__items"] && !Shopify.designMode) return;
  try {
    
    $(".kv-slide").slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 700,
      arrows: false,
      dots: true,
      appendDots: $(".kv-slide-dots"),
      responsive: [
        {
          breakpoint: 896, //ブレイクポイントを指定
          settings: {
            slidesToShow: 1.5,
            centeredSlides: true
            
          },
        },
      ],
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page__bosai__slide"] && !Shopify.designMode) return;
  try {
    
    $(".kv-slide").slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
      speed: 700,
      arrows: false,
      dots: true,
      appendDots: $(".kv-slide-dots"),
      responsive: [
        {
          breakpoint: 896, //ブレイクポイントを指定
          settings: {
            slidesToShow: 1.5,
            centeredSlides: true
            
          },
        },
      ],
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector(".new-slide");
    if (slider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(slider).slick({
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 896,
            settings: {
              infinite: true,
              centerMode: true,
              centerPadding: '20%',
              slidesToShow: 1,
              autoplay: false,
              arrows: false,
              dots: false,
            },
          },
        ],
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-other"] && !Shopify.designMode) return;
  try {
    
  // Shopifyのエディタ上で変更があった際にスライダーを再起動させるための処理
  const initOtherSlider = () => {
    const sliderEl = document.querySelector(".other-banner");
    if (!sliderEl || typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;
    const $slider = jQuery(sliderEl);
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
    $slider.slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 700,
      arrows: true,
      dots: false,
      responsive: [
        {
          breakpoint: 896,
          settings: {
            slidesToShow: 1,
            dots: true,
          },
        },
      ],
    });
  };

  document.addEventListener('DOMContentLoaded', function() {
    initOtherSlider();
  });

  // 管理画面での動的変更に対応
  document.addEventListener('shopify:section:load', initOtherSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-pickUp"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector(".pickUp-slide");
    if (slider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(slider).slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 896,
            settings: {
              infinite: true,
              centerMode: true,
              centerPadding: '20%',
              slidesToShow: 1,
              autoplay: false,
              arrows: false,
              dots: false,
            },
          },
        ],
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top__banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector(".top__banner-slide");
    if (slider && typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
      jQuery(slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        arrows: true,
        dots: true,
        responsive: [
          {
            breakpoint: 896,
            settings: {
              infinite: true,
              centerMode: false,
              slidesToShow: 1,
              autoplay: false,
              arrows: false,
              dots: true
            }
          }
        ]
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
